import React from 'react'
import Grid from '@material-ui/core/Grid'
import ValidatedAutocomplete from '../../../../_global/ValidatedAutocomplete'
import { default as useGetTagsQuery } from '../../../../apolloClient/queries/getTags'

const AccomplishmentTags = ({ setFieldValue, onboardingFormName, label }) => {
  const { loading, error, data } = useGetTagsQuery()
  if (loading) return <p>{`Loading: ${JSON.stringify(loading)}`}</p>
  if (error) return <p>{`Error: ${JSON.stringify(error)}`}</p>
  const { certificates, languages } = data.getTags

  return (
    <Grid item xs={12} sm={11}>
      <ValidatedAutocomplete
        label={label}
        onChange={(e, value) => {
          return setFieldValue(`${onboardingFormName}`, value, true)
        }}
        options={onboardingFormName === 'certificates' ? certificates.values : languages.values}
        name={onboardingFormName}
        multiple={true}
      />
    </Grid>
  )
}

export default AccomplishmentTags
